import React from 'react';
import DecorBackground from '@/components/marketing/DecorBackground';
import Reveal from '@/components/marketing/Reveal';

const GEOS = ['IN', 'US', 'BR', 'ID', 'PH', 'DE', 'AE'];
const BADGES = [
  { label: 'Source Controls', tone: '#22D3EE' },
  { label: 'Format Routing', tone: '#3B82F6' },
  { label: 'Anti-Fraud Signals', tone: '#34D399' },
  { label: 'Top-Up Launch', tone: '#FBBF24' },
];

export default function GlobalTrafficStrip() {
  return (
    <section className="relative bg-[#060B18] text-white isolate overflow-hidden border-y border-white/5" data-testid="global-traffic-strip">
      <DecorBackground variant="section" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
            <span className="shrink-0 text-[10.5px] uppercase tracking-[0.22em] text-slate-400">
              <span className="text-[#22D3EE] font-semibold">Global</span> Traffic Layer
            </span>
            <div className="relative flex-1">
              {/* glow line */}
              <div
                className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-px"
                style={{ background: 'linear-gradient(90deg, transparent, rgba(34,211,238,0.55), rgba(139,92,246,0.55), rgba(34,211,238,0.55), transparent)' }}
                aria-hidden
              />
              <div className="relative flex flex-wrap items-center gap-2.5">
                {GEOS.map((g, i) => (
                  <span
                    key={g}
                    className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#0B172A]/85 border border-white/10 backdrop-blur-md text-[11.5px] font-display font-semibold text-white"
                    style={{ boxShadow: `0 0 18px rgba(34,211,238,${0.15 + (i % 3) * 0.06})` }}
                  >
                    <span className="h-1.5 w-1.5 rounded-full bg-[#22D3EE] pulse-glow" style={{ animationDelay: `${i * 0.4}s` }} />
                    {g}
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div className="mt-5 flex flex-wrap gap-2">
            {BADGES.map((b) => (
              <span
                key={b.label}
                className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/[0.03] border text-[11.5px] font-medium"
                style={{ color: b.tone, borderColor: `${b.tone}40` }}
              >
                <span className="h-1.5 w-1.5 rounded-full" style={{ background: b.tone, boxShadow: `0 0 10px ${b.tone}` }} />
                {b.label}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
